import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MainService } from '../../main.service';

@Component({
  selector: 'app-cancel',
  templateUrl: './cancel.component.html',
  styleUrls: ['./cancel.component.scss']
})
export class CancelComponent implements OnInit {

  token: string;
  state: 'loading' | 'confirm' | 'processing' | 'cancelled' | 'request_sent' | 'already_cancelled' | 'already_requested' | 'past' | 'error' = 'loading';
  reservation: any = null;

  constructor(
    private route: ActivatedRoute,
    private mainService: MainService,
    private translate: TranslateService
  ) {
    translate.addLangs(['en', 'pl', 'ru', 'ua']);
    translate.setDefaultLang('en');
  }

  ngOnInit() {
    this.token = this.route.snapshot.paramMap.get('token');
    this.loadReservation();
  }

  loadReservation() {
    this.state = 'loading';
    this.mainService.getReservationByToken(this.token).subscribe(
      (res: any) => {
        if (res.status === 'ok') {
          this.reservation = res.reservation;

          // Set language from reservation
          const lang = this.reservation.language;
          if (lang && lang.match(/en|pl|ru|ua/)) {
            this.translate.use(lang);
          } else {
            const browserLang = this.translate.getBrowserLang();
            this.translate.use(browserLang.match(/en|pl|ru|ua/) ? browserLang : 'en');
          }

          if (this.reservation.is_cancelled) {
            this.state = 'already_cancelled';
          } else if (this.reservation.is_past) {
            this.state = 'past';
          } else if (this.reservation.is_cancellation_requested) {
            this.state = 'already_requested';
          } else {
            this.state = 'confirm';
          }
        } else {
          this.state = 'error';
        }
      },
      () => {
        this.state = 'error';
      }
    );
  }

  cancelReservation() {
    this.state = 'processing';

    if (this.reservation.is_paid) {
      this.mainService.requestCancellation(this.token).subscribe(
        (res: any) => {
          if (res.status === 'request_sent') {
            this.state = 'request_sent';
          } else if (res.status === 'already_requested') {
            this.state = 'already_requested';
          } else if (res.status === 'already_cancelled') {
            this.state = 'already_cancelled';
          } else {
            this.state = 'error';
          }
        },
        () => {
          this.state = 'error';
        }
      );
    } else {
      this.mainService.cancelReservation(this.token).subscribe(
        (res: any) => {
          if (res.status === 'cancelled') {
            this.state = 'cancelled';
          } else if (res.status === 'already_cancelled') {
            this.state = 'already_cancelled';
          } else {
            this.state = 'error';
          }
        },
        () => {
          this.state = 'error';
        }
      );
    }
  }
}
